// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"08ff98f2","114":"87c7ed1c","334":"f5bb579f","453":"d536dbc0","591":"7d81e738","618":"98c9e888","821":"43637ff8","834":"4ebe4118","878":"0f40899a","943":"15779eab"}[chunkId] + ".chunk.js";
};